import { render, staticRenderFns } from "./ContactTasks.vue?vue&type=template&id=a2e9dda4&scoped=true"
import script from "./ContactTasks.vue?vue&type=script&lang=js"
export * from "./ContactTasks.vue?vue&type=script&lang=js"
import style0 from "./ContactTasks.vue?vue&type=style&index=0&id=a2e9dda4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e9dda4",
  null
  
)

export default component.exports